import {
  inputShadowX,
  inputShadowY,
  lightPorcelain,
  lynch,
  sanJuan
} from 'components/style/Colors.style';
import styled, { css } from 'styled-components';
import { Input } from 'reactstrap';
import { labelLetterSpacing } from 'components/style/Headings.style';

const inputStyle = css`
  background-color: ${lightPorcelain};
  &,
  &:focus {
    box-shadow: 0 1px 3px 0 ${inputShadowY}, 0 0 0 1px ${inputShadowX};
  }

  color: ${sanJuan};
  &::placeholder {
    ${labelLetterSpacing};
    font-weight: 500;
    color: ${lynch};
  }
`;

export const FormInput = styled(Input).attrs({
  className: 'form-control form-rounded'
})`
  ${inputStyle};
`;

export const TextArea = styled.textarea.attrs({
  className: 'form-control form-rounded'
})`
  ${inputStyle};
`;



// WEBPACK FOOTER //
// ./src/components/style/Inputs.style.js